import Api from '../Utils/Axios';

export const GetSymptomList = async (searchValue = "") => {
    const response = await Api.get(`symptom/list?search=${searchValue}`);
    return response.data;
  };

  export const DragAndDropSymptom = async (data) => {
    const response = await Api.post('symptom/changeOrder',data);
    return response.data;
  };

  export const DeleteSymptom = async (id) => {
    const response = await Api.delete(`symptom/${id}`);
    return response.data;
  };

  export const CreateSymptom = async (data) => {
    const response = await Api.post('symptom/',data);
    return response.data;
  };


  export const GetSingleSymptom = async (id) => {
    const response = await Api.get(`symptom/${id}`);
    return response.data;
  };

  export const UpdateSymptom = async (data) => {
    const response = await Api.put('symptom/',data);
    return response.data;
  };

  export const updateSymptomStatus = async (data) => {
    const response = await Api.post(`symptom/changeStatus`, data);
    return response.data;
  };